// https://vuex.vuejs.org/en/actions.html

import { db , auth} from '../utils/firebase'

export default {

  userSignIn ({ commit, state }, user) {
    if(state.debug) console.log('Executing User Sign In')
    if(user) {
      commit('SET_USER', user) // Save firebase user
      commit('SET_IS_LOGGED') // Save logged in status
      db.collection('Users').where('firebase_uid', '==', user.uid)
      .get()
      .then((querySnapshot) => {
        if(querySnapshot.docs.length != 1) {
          console.error('Multiple matches for user, using first match')
        }
        if(querySnapshot.docs.length > 0) {
          if(state.debug) console.log('Accessing user:', querySnapshot.docs[0].data())
          let docData = querySnapshot.docs[0].data()
          commit('SET_UID', docData.uid)
          commit('SET_EMAIL', docData.email)
          commit('SET_DISPLAY_NAME', docData.display_name)
          commit('SET_LEVEL', docData.level)
          if(state.debug) console.log('Logged in:', state.email)
          commit('SET_NOTIFY_MESSAGE', `Signed in as ${state.email}`)
        } else {
          console.error('Could not find matching user for fb uid:', user.uid)
        }
      })
    } else {
      if(state.debug) console.log('No User to sign in.')
    }

    
  },

  userSignOut({ commit, state }) {
    if (state.debug) console.log('Sign Out, reset store')
    commit('CLEAR_UID')
    commit('CLEAR_USER')
    commit('CLEAR_DISPLAY_NAME')
    commit('CLEAR_LEVEL')
    commit('CLEAR_EMAIL')
    commit('CLEAR_IS_LOGGED')
    commit('SET_NOTIFY_MESSAGE', `Signed Out`)
    return auth.signOut().then(function () {
      if (state.debug) console.log('Signed Out')
      return document.location.reload();
    })
  },


  getNews ({ state }, page) {
    if (state.debug) console.log('Getting News from Database')
    return db.collection('Config').doc('news')
    .get()
    .then((doc) => {
      let docData = doc.data()
      if(state.debug) console.log('News data is:', docData)
      return docData[page]
    })
  },

  listenerAllProducts ({ commit, state }) {
    if (state.debug) console.log('Listener All Products')

    // Listener on products in database
    return db.collection('Products')
    .onSnapshot((querySnapshot) => {
      let products = querySnapshot.docs.map(doc => {
        let docData = doc.data()
        docData['wholesale_price'] = docData.wholesale_price ? Number(docData.wholesale_price) : Number(docData.base_price) * Number(docData.wholesale_rate)
        docData['wholesale_price_str'] = '$' + docData.wholesale_price.toFixed(2) 
        docData['base_price_str'] = '$' + docData.base_price.toFixed(2)
        docData['tags'] = docData.tags.sort() // Make them alphabetical
        docData['tags'] = docData.tags.join(', ') // Make them comma separated
        return docData
      
      })
      commit('SET_ALL_PRODUCTS', products)
      if (state.debug) console.log('All Products Updated: ', products)
    })
  
  },
  
  getVariants (variant) {
    return db.collection('Variants').doc(variant.toString())
    .get()
    .then((doc) => {
      if(doc.exists) {
        return doc.data()
      } else {
        return null
      }
    })

  },

  addProduct({ commit }, product) { // Will add product to active order (or update it if it matches and existing product)

    if(product.selection[0] == 'Other') {
      product['orderCode'] = 'CUSTOM'
    } else {
      let colorCode = product.selection[1] ? product.selection[1].toString().toUpperCase().substr(0,3) + product.selection[1].toString().toUpperCase().substr(product.selection[1].length - 3,) : 'NONE'

      let codeTop = product.code
      let codeMiddle = product.variants.codes[product.selection[0]]
      let codeBottom = product.variants.codes[product.selection[1]] ? product.selection[1].toString().toUpperCase().replace(/ /g,'') : colorCode.replace(/ /g,'')
      let codeFull = codeTop.toString() + '-' + codeMiddle.toString() + '-' + codeBottom.toString()
  
      product['orderCode'] = codeFull
    }

    commit('ADD_THIS_ORDER', product)

    return true
  },


  updateProduct({ commit, state }, product) { // Will add product to active order (or update it if it matches and existing product)

    if(product.selection[0] == 'Other') {
      product['orderCode'] = 'CUSTOM'
    } else {
      let colorCode = product.selection[1] ? product.selection[1].toString().toUpperCase().substr(0,3) + product.selection[1].toString().toUpperCase().substr(product.selection[1].length - 3,) : 'NONE'

      let codeTop = product.code
      let codeMiddle = product.variants.codes[product.selection[0]]
      let codeBottom = product.variants.codes[product.selection[1]] ? product.selection[1].toString().toUpperCase().replace(/ /g,'') : colorCode.replace(/ /g,'')
      let codeFull = codeTop.toString() + '-' + codeMiddle.toString() + '-' + codeBottom.toString()
  
      product['orderCode'] = codeFull
    }

    let selectedProductIndex = state.thisOrder.findIndex((element) => {
      return (element.index == product.index)
    });

    if(selectedProductIndex >= 0)  {
      commit('UPDATE_THIS_ORDER', {value: product, index: selectedProductIndex})
    } else commit('ADD_THIS_ORDER', product)

    return true
  },

  removeProduct({ commit, state }, product) {

    let selectedProductIndex = state.thisOrder.findIndex((element) => {
      return (element.title == product.title) && (element.selection == product.selection) && (element.quantity == product.quantity)
    });
    if(selectedProductIndex >= 0)  {
      commit('REMOVE_THIS_ORDER', selectedProductIndex)
      return true
    } else return false
  },
}
